import React, { useState } from 'react';
import SingleDayWaterReadingHistory from './single_day_meter_reading_history';
import DailyWaterReadingHistory from './daily_meter_reading_history';
import MonthlyWaterReadingHistory from './monthly_meter_reading_history';

function ReadingHistoryTab({ onExport, meterId }) {
    // State to track the selected view type from dropdown
    const [viewType, setViewType] = useState('per-day'); // Default to Per Day view

    // Handle view type change from dropdown
    const handleViewTypeChange = (e) => {
        setViewType(e.target.value);
    };

    return (
        <div className="tab-pane active" id="readings-tab">
            <div className="card">
                <div className="card-header">
                    <div className="d-flex justify-content-end align-items-center">
                        {/* View type dropdown selector */}
                        <div className="me-3">
                            <select 
                                id="viewType" 
                                className="form-select form-select-sm" 
                                value={viewType} 
                                onChange={handleViewTypeChange}
                            >
                                <option value="per-day">Per Day</option>
                                <option value="daily">Daily</option>
                                <option value="monthly">Monthly</option>
                            </select>
                        </div>
                        
                        {/* Export buttons */}
                        <div className="dropdown">
                            <button 
                                type="button" 
                                className="btn btn-sm btn-primary dropdown-toggle" 
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <i className="ti ti-file-export me-1"></i> Export
                            </button>
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li>
                                    <button 
                                        className="dropdown-item" 
                                        onClick={() => onExport('pdf')}
                                    >
                                        <i className="ti ti-file-type-pdf me-1"></i> PDF
                                    </button>
                                </li>
                                <li>
                                    <button 
                                        className="dropdown-item" 
                                        onClick={() => onExport('excel')}
                                    >
                                        <i className="ti ti-file-spreadsheet me-1"></i> Excel
                                    </button>
                                </li>
                                <li>
                                    <button 
                                        className="dropdown-item" 
                                        onClick={() => onExport('csv')}
                                    >
                                        <i className="ti ti-file-csv me-1"></i> CSV
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div className="card-body">
                    {/* Render the appropriate component based on viewType */}
                    {viewType === 'per-day' && (
                        <SingleDayWaterReadingHistory meterId={meterId} />
                    )}
                    
                    {viewType === 'daily' && (
                        <DailyWaterReadingHistory meterId={meterId} />
                    )}
                    
                    {viewType === 'monthly' && (
                        <MonthlyWaterReadingHistory meterId={meterId} />
                    )}
                </div>
            </div>
        </div>
    );
}

export default ReadingHistoryTab;